import React, { useEffect, useRef, useState } from 'react';
import { motion, useMotionValue, useTransform, animate, useInView } from 'framer-motion';
import './deliveriesCount.css';
import { useSelector } from 'react-redux';

const AnimatedNumber = ({ value }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: '-100px'});
  const motionValue = useMotionValue(0);
  const formatted = useTransform(motionValue, latest => Math.floor(latest).toLocaleString());

  useEffect(() => {
    const target = parseInt(value?.toString().replace(/,/g, ''), 10);
    if (isInView && target != null) {
      motionValue.set(0);
      const controls = animate(motionValue, target, {
        duration: 1.2,
        ease: 'easeOut',
      });
      return () => controls.stop();
    }
  }, [isInView, value]);

  return <motion.h1 ref={ref}>{formatted}</motion.h1>;
};

const DeliveriesCount = () => {
  const data = useSelector((store) => store.data.HomeData);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    const statsSection = data?.items?.find(item => item.Section === 'Stats');
    if (statsSection?.Content?.Stats) {
      setStats(statsSection.Content);
    }
  }, [data]);

  return (
    <div className="scroll-section">
      <motion.h1
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="heading capitalize-first-letter"
      >
        {stats.Title}
      </motion.h1>

      <div className="cards-container">
        {stats?.Stats?.map((card, index) => (
          <motion.div
            key={`${card.title}-${index}`}
            className="card "
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
          >
            <AnimatedNumber value={card.Value} />
            <h4 className="capitalize-first-letter">{card.Label}</h4>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default DeliveriesCount;
